import React from "react";

interface DialogFooterProps {
    full?: boolean;
    children?: any;
}

class DialogFooter extends React.Component<DialogFooterProps> {
    render() {
        return (
            <footer className="dialog-footer">
                <div className={`dialog-footer-inner ${this.props.full ? "full" : ""}`}>
                    {this.props.children}
                </div>
            </footer>
        );
    }
}

export default DialogFooter;
